import { useCallback } from 'react';
import { notificationDrawerStore } from './store';

/**
 * Centralized navigation state manager
 * Handles cross-component navigation concerns
 */

export interface NavigationEventData {
  shouldCloseDrawers?: boolean;
  shouldCloseModals?: boolean;
  fromComponent?: string;
}

export const useNavigation = () => {

  const closeAllOverlays = useCallback(() => {
    // Close notification drawer
    if (notificationDrawerStore.isOpen) {
      notificationDrawerStore.isOpen = false;
    }

    // Add other overlay closures here as needed
    // modalStore.isOpen = false;
    // tooltipStore.isOpen = false;
  }, []);

  const closeDrawersExcept = useCallback((exception?: string) => {
    if (exception !== 'notifications' && notificationDrawerStore.isOpen) {
      notificationDrawerStore.isOpen = false;
    }

    // Add other conditional closures here
  }, []);

  const handleNavigationEvent = useCallback((eventData: NavigationEventData) => {
    if (eventData.shouldCloseDrawers) {
      closeAllOverlays();
    }

    if (eventData.shouldCloseModals) {
      // Handle modal closures
    }
  }, [closeAllOverlays]);

  const openNotificationDrawer = useCallback(() => {
    notificationDrawerStore.isOpen = true;
  }, []);

  const closeNotificationDrawer = useCallback(() => {
    notificationDrawerStore.isOpen = false;
  }, []);

  const toggleNotificationDrawer = useCallback(() => {
    notificationDrawerStore.isOpen = !notificationDrawerStore.isOpen;
  }, []);

  return {
    closeAllOverlays,
    closeDrawersExcept,
    handleNavigationEvent,
    openNotificationDrawer,
    closeNotificationDrawer,
    toggleNotificationDrawer,
  };
};

export type NavigationHook = ReturnType<typeof useNavigation>;